import { Text } from '@volkswagen-onehub/components-core';
import React, { useEffect, useState } from 'react';
import { CanalDeContacto, CarlineSelect, CodigoPostal, ConsentQuestion, DetalleMotivo, Loading, NombreApellidos, TelefonoEmail } from 'src/components';
import { useIsComerciales } from 'src/feature-app/hooks';
import { LayoutWrapper } from 'src/feature-app/Screen';
import { ConfirmacionLeadsNoQuestions, leadsMasInformacionPartialData, LegalDatosPersonalesLeads, MapaLeads } from 'src/forms';
import { MapaLeadsInPage } from 'src/forms/Leads/InPage';
import { FormInfo, Steps } from 'src/types';
import { LeadGenericoController } from '../LeadGenericoController';
import { LeadsFormsProps } from '../LeadGenericoForm';
import { useInitializeLeadForm } from '../use-initialize-lead-form';

const getMapaFields = (inPage: boolean) => {
	if (inPage === true) {
		return <MapaLeadsInPage formName="masInformacion" />;
	} else {
		return <MapaLeads formName="masInformacion" />;
	}
};

enum MasInformacionSteps {
	Modelo,
	Mapa,
	NombreApellido,
	CodigoPostal,
	Contacto,
	EmailTelefono,
	Comentarios,
	Lssi,
	Tmk,
	Confirmacion,
}

export function MasInformacionForm({ updatedFormData, inPage, isConfigurador, isLeadDealer }: LeadsFormsProps) {
	const isComerciales = useIsComerciales();

	const [partialData, setPartialData] = useState(null);

	useEffect(() => {
		if (updatedFormData) {
			setPartialData(updatedFormData);
		} else {
			setPartialData(leadsMasInformacionPartialData(isConfigurador, isLeadDealer));
		}
	}, []);

	const defaultSteps: Steps[] = [
		{
			title: (
				<>
					<Text bold>¿Qué modelo </Text> te interesa?
				</>
			),
			fields: (
				<LayoutWrapper>
					<CarlineSelect useCarline={true} />
				</LayoutWrapper>
			),
			screenIndex: MasInformacionSteps.Modelo,
			name: 'Modelo',
			outputs: ['modelo'],
			outputsText: ['modelo'],
		},
		isLeadDealer
			? null
			: {
					screenIndex: MasInformacionSteps.Mapa,
					name: 'Mapa',
					multiStep: true,
					component: getMapaFields(inPage),
			  },
		{
			title: (
				<>
					Para poder preparar tu visita, necesitamos saber <Text bold>quién eres</Text>
					<LegalDatosPersonalesLeads />
				</>
			),
			fields: (
				<LayoutWrapper>
					<NombreApellidos />
				</LayoutWrapper>
			),
			screenIndex: MasInformacionSteps.NombreApellido,
			name: 'NombreApellido',
			outputs: ['name', 'surname', 'secondSurname'],
			outputsText: ['name', 'surname', 'secondSurname'],
		},
		{
			title: (
				<>
					También nos gustaría conocer <Text bold>tu código postal</Text>
				</>
			),
			fields: (
				<LayoutWrapper>
					<CodigoPostal />
				</LayoutWrapper>
			),
			screenIndex: MasInformacionSteps.CodigoPostal,
			name: 'CodigoPostal',
			outputs: ['codigoPostal'],
			outputsText: ['codigoPostal'],
		},
		{
			title: (
				<>
					<Text bold>¿Cómo prefieres </Text>que contactemos contigo?
					<sup style={{ top: 'auto', fontSize: '100%' }}>*</sup>
				</>
			),
			fields: (
				<LayoutWrapper>
					<CanalDeContacto />
				</LayoutWrapper>
			),
			screenIndex: MasInformacionSteps.Contacto,
			name: 'Contacto',
			outputs: ['contacto'],
			outputsText: ['contacto'],
		},
		{
			title: (
				<>
					Para ello necesitaremos <Text bold>tus datos de contacto</Text>
				</>
			),
			fields: (
				<LayoutWrapper>
					<TelefonoEmail hidePrefijo={isComerciales} requiredTelefono requiredEmail />
				</LayoutWrapper>
			),
			screenIndex: MasInformacionSteps.EmailTelefono,
			name: 'EmailTelefono',
			outputs: ['cellphone', 'email'],
			outputsText: ['cellphone', '/', 'email'],
		},
		{
			title: (
				<>
					¿Quieres saber <Text bold>algo en concreto</Text>?
				</>
			),
			fields: (
				<LayoutWrapper>
					<DetalleMotivo name="comments" />
				</LayoutWrapper>
			),
			screenIndex: MasInformacionSteps.Comentarios,
			name: 'Comentarios',
			outputs: ['comments'],
			outputsText: ['comments'],
		},
		{
			fields: <ConsentQuestion questionType="lssi" />,
			screenIndex: MasInformacionSteps.Lssi,
			name: 'lssi',
			outputs: ['lssi'],
		},
		{
			fields: <ConsentQuestion questionType="tmk" />,
			screenIndex: MasInformacionSteps.Tmk,
			name: 'tmk',
			outputs: ['tmk'],
		},
		{
			fields: <ConfirmacionLeadsNoQuestions />,
			screenIndex: MasInformacionSteps.Confirmacion,
			isLastStep: true,
			hidePreviousStep: true,
			name: 'Confirmacion',
		},
	];
	const filteredSteps = defaultSteps.filter((step) => step !== null);

	const { loading, steps, firstStep, lastStep } = useInitializeLeadForm(filteredSteps, false, inPage);

	const citaVentaInfo: Partial<FormInfo> = {
		numberOfScreens: steps.length,
	};

	return loading ? <Loading /> : <LeadGenericoController steps={steps} leadData={partialData} leadInfo={citaVentaInfo} firstStep={firstStep} lastStep={lastStep} inPage={inPage} isConfigurador={isConfigurador} />;
}
